import {
  getProductWithCategory,
  getUniqueCategories,
} from "../../helpers/product";
import React from "react";
import { setActiveSort } from "../../helpers/product";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { Button } from "@mui/material";
const ShopProductCategory = ({
  products,
  getSortParams,
  sideSpaceClass,
  value,
  setSortValues,
  tag,
}) => {
  products = products.filter((product) => product.tag.includes(tag));
  const uniqueCategories = getUniqueCategories(products)?.sort();
  const history = useHistory();
  return (
    <div className="row g-4">
      <div>
        <Button onClick={() => history.goBack()}>
          <ArrowBackIcon />
        </Button>
      </div>
      {uniqueCategories?.map((category) => {
        if (category === "") return null;
        const numArt = getProductWithCategory(products, category);
        return (
          <div
            className={
              "col-12 " + global.aziendaID == 4 ? "col-md-6" : "col-md-2"
            }
            key={category}
            onClick={(e) => {
              if(document
                .querySelector("#allCategories")) document
                .querySelector("#allCategories")
                .classList.remove("active");
              if (e.currentTarget.classList.contains("active"))
                getSortParams("category", category, "-");
              else getSortParams("category", category, "+");
              setActiveSort(e);
            }}
          >
            <div className="card text-center shadow-sm border-0"  style={{height:"200px"}}>
            <div className="card-body" 
              style={{
                backgroundImage: 
    "linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('"+global.baseUrlImage + "tag/foto categorie/" + category + ".png"+"')", backgroundSize: "cover", backgroundPosition: "center",
  
                alignItems:"center",
                justifyContent:"center",
                display: "flex", flexDirection: "column"
              }}>
                {/*<div className="p-3 bg-white text-white rounded-circle d-inline-block mb-3 border border-primary border-5">*/}
                  {/*<img
                    src={global.baseUrlImage + "tag/" + category + ".png"}
                    width="32"
                    height="32"
                  />*/}
                {/*</div>*/}
                <h3 className="card-title" style={{color:"white"}}>{category}</h3>
                <h5 className="card-text " style={{color:"white"}}>{numArt} prodotti</h5>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ShopProductCategory;
